export class Duankeugoidautu{
  id: number;
  tenDuAn: string;
  mucTieuChinh : string;
  linhVucChuyenMon : string;
  loaiDuAn : string;
  diaDiemDauTu : string;
  thoiGianThuHien : string;
  kinhPhi : string;
  nguonKinhPhi : string;
  fileDinhKem : string;
  tinhTrang : number;
  duyetBai : number;
  denTGTT : string;
  //donVi : string;
  diaDiem : string;
  isActive: number;
  createdDate: Date;
  createdByUserID: number;
  modifiedByUserID: number;
  modifiedDate: Date;  
  donViID : number;
  getFiles : string[];
  trongdiem: number;
  diachilienhe:string; 
 }